export const getUniqueSearchId = (() => {
  let counter = 0;
  return () => `queryID-${counter++}`;
})();
